import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import Directories from "../components/Home/Directories";
import FormHome from "../components/Home/FormHome";
import Map from "../components/Contact/MapContent";
import BaseLayout from "../components/global/BaseLayout";
import CounterUp from "../components/global/CounterUp";
import ServicesHome from "../components/Home/ContentServicesHome";
import HeroSection from "../components/Home/HeroVideo";
import Paletacolor from "../components/global/Paletacolor";
import BlockPrincipal from "../components/block/Block_swiper";
import BlockSecondary from "../components/block/Block_71";
import BlockAbout from "../components/block/Block_7";
import SlideBlock from "../components/block/SlideLogoForm";
import VideoPromocional from "../components/global/VideoPromocional";
import ContentServices from "../components/Services/ContentServices";
import GalleryContent from "../components/Gallery/GalleryContent";
// import Modal from "../components/Home/Modal";
// import CustomReviews from "../components/reviews/CustomReviews";
import ValuesOne from "../components/values/Values_2";
import ModalPost from "../components/Home/ModalPost";

// para agregar la frase de los años de experiencia o la licencia agregar sloganPrincipal={true}
// para agregar la lista de about agregar listsAbout={true}
// para agregar la lista de servicios agregar listsServices={true}

function Home() {
  const { rpdata } = useContext(GlobalDataContext);
  return (
    <BaseLayout PageName="Home">
      <div className="md:max-w-full w-full">
        {/* <Modal /> */}
        <ModalPost />

        <input className="absolute -z-50" autoFocus></input>
        <HeroSection
          title={rpdata?.dbSlogan?.[3]?.slogan}
          texts={rpdata?.dbValues?.[0].description}
          slogan={rpdata?.dbSlogan?.[10]?.slogan}
          urlVideo={"https://firebasestorage.googleapis.com/v0/b/resource-36ef7.appspot.com/o/Videos%2FVideosCiudades%2FCharlotte%2C%20NC.mp4?alt=media&token=08ceaafb-5be0-4132-be41-d5e381986fbd"}
          bgImg={rpdata?.gallery?.length > 20 ? rpdata?.gallery?.[20] : rpdata?.stock?.[0]}
          bgImg1={rpdata?.gallery?.length > 1 ? rpdata?.gallery?.[1] : rpdata?.stock?.[1]}
          bgImg2={rpdata?.gallery?.length > 2 ? rpdata?.gallery?.[2] : rpdata?.stock?.[2]}
          bgImg3={rpdata?.gallery?.length > 3 ? rpdata?.gallery?.[3] : rpdata?.stock?.[3]}
        />
        <BlockPrincipal
          title={rpdata?.dbSlogan?.[2]?.slogan}
          text={rpdata?.dbHome?.[0].text}
          image={rpdata?.gallery?.length > 4 ? rpdata?.gallery?.[4] : rpdata?.stock?.[2]}
          corte={rpdata?.gallery?.length > 0 ? rpdata?.gallery : rpdata?.stock}
          sloganPrincipal={true}
          listServices={true}
        />
        {/* Servicios del home */}
        {
          rpdata?.simpleWidgets?.[3]?.activo ?
            <div className="pt-20">
              <ContentServices />
            </div>
            :
            <ServicesHome />
        }
        <Directories />

        {/* video promocional */}
        {
          rpdata?.videosPromo?.[0]?.activo ?
            <VideoPromocional
              title={rpdata?.dbSlogan?.[2]?.slogan}
              text={rpdata?.dbAbout?.[1]?.text}
              linkVideo={`${rpdata?.videosPromo?.[0].link}`}
              image={`${rpdata?.videosPromo?.[0].img}`}

            />
            : null

        }
        <SlideBlock
          title={'a little about us'}
          text={rpdata?.dbValues?.[2].description}
          image={rpdata?.gallery?.length > 5 ? rpdata?.gallery?.[5] : rpdata?.stock?.[5]}
        />
        <BlockAbout
          title={'a little about us'}
          text={rpdata?.dbAbout?.[1]?.text}
          image1={rpdata?.gallery?.length > 6 ? rpdata?.gallery?.[6] : rpdata?.stock?.[6]}
          image2={rpdata?.gallery?.length > 7 ? rpdata?.gallery?.[7] : rpdata?.stock?.[7]}
          image3={rpdata?.gallery?.length > 8 ? rpdata?.gallery?.[8] : rpdata?.stock?.[8]}
          listsAbout={true}
        />
        <ValuesOne image1={rpdata?.gallery?.length > 9 ? rpdata?.gallery?.[9] : rpdata?.stock?.[9]} />
        <CounterUp image={rpdata?.gallery?.length > 10 ? rpdata?.gallery?.[10] : rpdata?.stock?.[10]} />
        <BlockSecondary
          title={rpdata?.dbSlogan?.[8]?.slogan}
          text={rpdata?.dbHome?.[1]?.text}
          image={rpdata?.gallery?.length > 11 ? rpdata?.gallery?.[11] : rpdata?.stock?.[11]} 
        />
        {/* our reviews */}
        {
          rpdata?.reviews?.isHomeOnly === true ?
            <div className="w-4/5 mx-auto py-[100px]">
              <h1 className="pb-10 text-center">{rpdata?.labels?.general?.titleReviews}</h1>
              <div className={`${rpdata?.reviews?.links?.[0]}`}></div>
            </div>
            : null
        }
        {/* <CustomReviews/> */}
        {/* Gallery cuando es OnePages */}
        {/* Paleta de Colores */}
        {
          rpdata?.simpleWidgets?.[3]?.activo ?
            <div className="pt-10 pb-28">
              <h2 className="text-center pb-[50px]">{rpdata?.labels?.general?.titleGallery}</h2>
              <GalleryContent galleryImages={rpdata?.stock?.length > 0 ? rpdata?.stock : rpdata?.stock} />
            </div>
            :
            null
        }
        {
          rpdata?.brandingExtra?.[0]?.activo ?
            <Paletacolor />
            : null
        }
        <div
          className="bgFormHome"
          style={{ backgroundImage: `url("${rpdata?.gallery?.[15]}")` }}
        >
          <div className="relative">
            <FormHome />
          </div>
        </div>
        <Map />
      </div>
    </BaseLayout>
  );
}

export default Home;
